export const GET_FEATURES = '[Features Action] Get Features';
export const CONFIRMED_GET_FEATURES = '[Features Action] Confirmed Get Features';
